export enum ResetPasswordError {
  InvalidResetPasswordCode = 'InvalidResetPasswordCode',
  ResetPasswordCodeExpired = 'ResetPasswordCodeExpired',
  InvalidUserStatus = 'InvalidUserStatus',
  PasswordSameAsLast = 'PasswordSameAsLast',
  PasswordMinimumRequiredLength = 'PasswordMinimumRequiredLength',
  UserNotFound = 'UserNotFound',
}
